import { generateUniqueHash } from 'fela-utils';

export default function generateMonolithicClassName(style) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (style.className) {
    var name = prefix + style.className;
    delete style.className;
    return name;
  }

  var hashedName = generateUniqueHash(style);
  return '' + prefix + hashedName;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-monolithic/es/generateMonolithicClassName.js
// module id = 972
// module chunks = 0